import type { ListProps } from "react-admin";
import { List, Datagrid, TextField, EmailField, TextInput } from "react-admin";

const adminFilters = [<TextInput key="q" source="q" label="Search" alwaysOn />];

const AdminList = (props: ListProps) => (
  <List {...props} filters={adminFilters}>
    <Datagrid rowClick="edit">
      <TextField source="name" />
      <EmailField source="email" />
      <TextField source="phoneNumber" emptyText="—" />
    </Datagrid>
  </List>
);

export default AdminList;
